import React from 'react';
import { useTheme, IconButton } from '@material-ui/core';
import { useSelector } from 'dva';
import { history, useIntl } from 'umi';
import styles from '../../../../cm/mm/components/table_page/TablePage.less?modules';
import AdjustmentDataResultStyled from './AdjustmentDataResultStyled';
import DataTableNativeML from '@/components/DataTableNativeML';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
import { fmtThousand } from '@/utils/comUtil.js';
import ButtonTip from '@/components/buttonTip/ButtonTip';

const AdjustmentDataResult = (props) => {
  const { setPageData, pagination } = props;
  const theme = useTheme();

  const intl = useIntl();
  const { formatMessage } = intl;
  // eslint-disable-next-line no-unused-vars
  const { viewList, allTotal } = useSelector((state) => state.adjustmentData);

  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['adjustmentData/getViewList'];

  const { data, total, hasNext } = viewList || {};

  const handleAdjustDetail = (item, isDetail) => {
    let toDetail = new Map([
      // 积分有效期调整2
      [
        formatMessage({ id: 'adjustment.members.c01.lbl17' }),
        // '积分有效期调整',
        {
          route: '/adjust/adjust_view/changeIntegral',
          status: 'changeIntegral',
          tab: 2,
        },
      ],
      // 转柜
      [
        // '转柜',
        formatMessage({ id: 'adjustment.members.c01.lbl18' }),
        { route: '/adjust/adjust_view/changeStore', status: 'changeStore' },
      ],
      [
        // '转柜',
        '服务门店变更',
        { route: '/adjust/adjust_view/changeStore', status: 'changeStore' },
      ],
      // 退会
      // ['EXIT', ['/marketing/scene/member']],
      // 积分调整
      [
        // '等级调整',
        formatMessage({ id: 'adjustment.members.c01.lbl19' }),
        { route: '/adjust/adjust_view/changeLevel', status: 'changeLevel' },
      ],
      // 积分调整
      [
        // '积分调整',
        formatMessage({ id: 'adjustment.members.c01.lbl20' }),
        {
          route: '/adjust/adjust_view/changeIntegral',
          status: 'changeIntegral',
          tab: 1,
        },
      ],
      [
        // '积分调整',
        '型动值调整',
        {
          route: '/adjust/adjust_view/changeMolding',
          status: 'changeIntegral',
          tab: 3,
        },
      ],
      [
        // '积分调整',
        '型动值有效期调整',
        {
          route: '/adjust/adjust_view/changeMolding',
          status: 'changeIntegral',
          tab: 4,
        },
      ],
      // 生日
      [
        // '生日',
        formatMessage({ id: 'adjustment.members.c01.lbl21' }),
        { route: '/adjust/adjust_view/edit', status: 'edit' },
      ],
      [
        // '卡券变更',
        '发放优惠券',
        {
          route: '/adjust/adjust_view/adjust_coupon_view_detail',
          status: 'detail',
        },
      ],
      [
        // '优惠券有效期调整',
        '优惠券有效期调整',
        {
          route: '/adjust/adjust_view/adjust_coupon_period_view_detail',
          status: 'detail',
        },
      ],
      [
        // '优惠券有效期调整',
        '优惠券失效调整',
        {
          route: '/adjust/adjust_view/adjust_coupon_failure_view_detail',
          status: 'detail',
        },
      ],
      [
        // '优惠券有效期调整',
        '会员解绑',
        {
          route: '/adjust/adjust_view/adjust_coupon_failure_view_detail',
          status: 'detail',
        },
      ],
    ]);
    if (item.type !== '会员解绑') {
      history.push({
        pathname: toDetail.get(`${item.type}`).route,
        query: {
          ...item,
          id: item.memberId,
          detailId: item.id,
          opt: isDetail,
          status: toDetail.get(`${item.type}`).status,
          tab: toDetail.get(`${item.type}`)?.tab,
        },
      });
    } else {
      history.push({
        pathname: '/adjust/adjust_list/unbind_member_detail',
        query: {
          id: item.memberId,
          detail: item.value,
          date: item.createDate,
        },
      });
    }
  };

  const columns = [
    {
      // title: '会员号',
      title: formatMessage({ id: 'adjustment.members.c01.lbl01' }),
      align: 'center',
      id: 'memberCode',
      key: 'memberCode',
      width: 165,
    },
    {
      // title: '手机号',
      title: formatMessage({ id: 'adjustment.members.c01.lbl03' }),
      align: 'center',
      id: 'mobile',
      key: 'mobile',
      width: 155,
    },
    {
      // title: '调整类型',
      title: formatMessage({ id: 'adjustment.members.c01.lbl13' }),
      align: 'center',
      id: 'type',
      key: 'type',
      width: 165,
    },
    {
      // title: '调整原因',
      title: formatMessage({ id: 'adjustment.members.c01.lbl14' }),
      align: 'center',
      id: 'remark',
      key: 'remark',
      width: 165,
    },
    {
      title: formatMessage({ id: 'adjustment.members.c01.lbl15' }),
      // title: '调整时间',
      align: 'center',
      width: 180,
      id: 'createDate',
      key: 'createDate',
    },
    {
      // title: '调整人',
      title: formatMessage({ id: 'adjustment.members.c01.lbl16' }),
      align: 'center',
      id: 'committer',
      key: 'committer',
      width: 125,
    },
    {
      // title: '操作',
      title: formatMessage({ id: 'adjustment.members.c01.lbl12' }),
      // width: 120,
      align: 'center',
      render: (item) => {
        return (
          <div align="center" className={styles.handle_btn}>
            {item.type !== '退会' && (
              <ButtonTip title={formatMessage({ id: 'comm.action.btn.05' })}>
                <IconButton
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  color="inherit"
                  onClick={() => handleAdjustDetail(item, 'preview')}
                >
                  <SvgIconML
                    size={24}
                    className="icon"
                    name={'detail'}
                  ></SvgIconML>
                </IconButton>
              </ButtonTip>
            )}
          </div>
        );
      },
      width: 200,
    },
  ];
  const headerTip = (
    <div className="number-wrapper">
      <div className="number">
        <span className="text">
          {formatMessage({ id: 'coupon.data.n02.lbl02' })}{' '}
        </span>
        <span> {fmtThousand(allTotal, 0)}</span>
      </div>
    </div>
  );
  return (
    <AdjustmentDataResultStyled theme={theme}>
      <DataTableNativeML
        total={total}
        loading={loading}
        paging={true}
        columns={columns}
        headerTip={headerTip}
        hasNext={hasNext}
        allTotal={allTotal}
        initP={true}
        page={pagination}
        changePage={(pageObj) => {
          setPageData(pageObj);
        }}
        data={data}
      ></DataTableNativeML>
    </AdjustmentDataResultStyled>
  );
};

export default AdjustmentDataResult;
